import { Box, useTheme } from '@mui/material';
import ErrorIcon from '@mui/icons-material/Error';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';

export type AlarmItemProps = {
  id: string;
  name: string;
  description: string;
  timestamp: string;
  type?: 'critical' | 'warning';
};

export const AlarmItem = ({ id, name, description, timestamp, type }: AlarmItemProps) => {
  const { palette } = useTheme();
  return (
    <Box key={id} sx={{ display: 'flex', flexDirection: 'row', mb: '8px' }}>
      <Box sx={{ marginRight: '5px' }}>
        {type === 'critical' ? (
          <ErrorIcon sx={{ color: palette.error.main }} />
        ) : (
          <ErrorOutlineIcon />
        )}
      </Box>
      <Box sx={{ display: 'flex', flexDirection: 'column' }}>
        <Box sx={{ color: palette.text.primary }}>{name}</Box>
        <Box sx={{ color: palette.text.secondary }}>{description}</Box>
        <Box sx={{ color: palette.text.secondary }}>{timestamp}</Box>
      </Box>
    </Box>
  );
};
